import y from "../common/base-provider.js";
import e from "../managers/braze-instance.js";
import Feed from "./feed.js";
import {
  newCardFromFeedJson as ht,
  newCardFromSerializedValue as S,
} from "../Card/util/card-factory.js";
import { rehydrateDateAfterJsonization as w } from "../util/date-utils.js";
import { STORAGE_KEYS as o } from "../managers/storage-manager.js";
import T from "../managers/subscription-manager.js";
export default class ee extends y {
  constructor(t, s) {
    super(),
      (this.u = t),
      (this.Ui = s),
      (this.cards = []),
      (this.ki = null),
      (this.u = t),
      (this.Ui = s),
      (this.Bt = new T()),
      e.Ht(this.Bt),
      this.Yt();
  }
  Yt() {
    let t = [];
    this.u && (t = this.u.j(o.C.Ai) || []);
    const s = [];
    for (let i = 0; i < t.length; i++) {
      const e = S(t[i]);
      null != e && s.push(e);
    }
    (this.cards = s), this.u && (this.ki = w(this.u.j(o.C.Bi)));
  }
  Ei(t) {
    const s = [];
    let i = null,
      e = {};
    this.u && (e = this.u.j(o.C.J) || {});
    const r = {};
    for (let h = 0; h < t.length; h++) {
      i = t[h];
      const o = ht(i);
      if (null != o) {
        const t = o.id;
        t && e[t] && ((o.viewed = !0), (r[t] = !0)), s.push(o);
      }
    }
    (this.cards = s),
      this.Ts(),
      (this.ki = new Date()),
      this.u && (this.u.I(o.C.J, r), this.u.I(o.C.Bi, this.ki));
  }
  Ts() {
    var t;
    const s = [];
    for (let t = 0; t < this.cards.length; t++) s.push(this.cards[t].Y());
    null === (t = this.u) || void 0 === t || t.I(o.C.Ai, s);
  }
  Ss(t) {
    null != t &&
      t.feed &&
      (this.Yt(),
      this.Ei(t.feed),
      this.Bt.Rt(new Feed(this.cards.slice(), this.ki)));
  }
  Gi() {
    this.Yt();
    const t = [],
      s = new Date();
    for (let i = 0; i < this.cards.length; i++) {
      const e = this.cards[i].expiresAt;
      let r = !0;
      null != e && (r = e >= s), r && t.push(this.cards[i]);
    }
    return new Feed(t, this.ki);
  }
  qs() {
    this.Ui && this.Ui.requestFeedRefresh();
  }
  si(t) {
    return this.Bt.Nt(t);
  }
  clearData(t) {
    null == t && (t = !1),
      (this.cards = []),
      (this.ki = null),
      t && this.u && (this.u.ii(o.C.Ai), this.u.ii(o.C.Bi)),
      this.Bt.Rt(new Feed(this.cards.slice(), this.ki));
  }
}
